module.exports = __webpack_public_path__ + "static/designer-detail.ca736852.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/designer-detail.png
// module id = 588
// module chunks = 35783957827783